
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('circle',{attrs:{"cx":"3.2","cy":"3.2","r":"3.2","transform":"translate(8.8 8.8)"}}),_c('path',{attrs:{"d":"M9 2L7.17 4H4a2.006 2.006 0 00-2 2v12a2.006 2.006 0 002 2h16a2.006 2.006 0 002-2V6a2.006 2.006 0 00-2-2h-3.17L15 2zm3 15a5 5 0 115-5 5 5 0 01-5 5z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      